import { Tag } from 'common-components'
import { PropsWithChildren } from 'react'

const DataLengthTag = ({ children }: PropsWithChildren<unknown>) => {
  return <Tag style={{ minWidth: 24, height: 22, justifyContent: 'center' }}>{children}</Tag>
}

export default DataLengthTag
